module.exports = __webpack_public_path__ + "static/media/team-member-04.2ddf25d1.jpg";